import { render } from "./IAView.vue?vue&type=template&id=266f00f7&scoped=true&ts=true"
import script from "./IAView.vue?vue&type=script&lang=ts"
export * from "./IAView.vue?vue&type=script&lang=ts"

import "./IAView.vue?vue&type=style&index=0&id=266f00f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266f00f7"]])

export default __exports__